import type { ChartData } from '@/entities/dashboard';

/**
 * Legacy RITA colors the service-user series itself (`welcome.js`), ignoring the
 * Highcharts default palette the API still sends. Keyed by the API's series name,
 * before `translateSeriesNames` swaps it for the locale's wording.
 */
const SERVICE_USER_COLORS: Record<string, string> = {
  'Released at Warehouse': '#f0c20c',
  'Released at Customer': '#c0392b',
  'Customer Delivery': '#34495e',
  'Picked Up': '#fd9c72'
};

export const applyServiceUserColors = (data: ChartData): ChartData => ({
  ...data,
  series: data.series.map((series) => ({ ...series, color: SERVICE_USER_COLORS[series.name] ?? series.color }))
});
